import { DiscountThreshold } from "../types/pos.types";
import axiosInstance from "../../../middlewares/axiosInstance";

interface GetDiscountThresholdRequest {
  store_id: string;
}

interface UpdateDiscountThresholdRequest {
  store_id: string;
  cashierMaxPercentageDiscount: number;
  cashierMaxFixedDiscount: number;
}

class SettingsService {
  private apiPath = "/business-admin/settings";

  async getDiscountThresholds(
    request: GetDiscountThresholdRequest
  ): Promise<DiscountThreshold> {
    try {
      const response = await axiosInstance.post(
        `${this.apiPath}/get_discount_thresholds`,
        {
          store_id: request.store_id,
        }
      );

      return response.data;
    } catch (error: any) {
      console.error("Error fetching discount thresholds:", error);
      throw new Error(
        error.response?.data?.error || "Failed to fetch discount thresholds"
      );
    }
  }

  async updateDiscountThresholds(
    request: UpdateDiscountThresholdRequest
  ): Promise<void> {
    try {
      const response = await axiosInstance.post(
        `${this.apiPath}/update-discount-thresholds`,
        {
          store_id: request.store_id,
          cashierMaxPercentageDiscount: request.cashierMaxPercentageDiscount,
          cashierMaxFixedDiscount: request.cashierMaxFixedDiscount,
        }
      );

      return response.data;
    } catch (error: any) {
      console.error("Error updating discount thresholds:", error);
      throw new Error(
        error.response?.data?.error || "Failed to update discount thresholds"
      );
    }
  }
}

export const settingsService = new SettingsService();
